import './button';


let wechatIcons = document.querySelectorAll('.social-media__wechat .wechat');
let qrcodeContainer = document.querySelector('.qrcode-container');
let closeButton = qrcodeContainer.querySelector('.close-button');

wechatIcons.forEach(wechat => {
  wechat.addEventListener('click', () => {
    qrcodeContainer.classList.add('shown');
  });
});

qrcodeContainer.addEventListener('click', () => {
  qrcodeContainer.classList.remove('shown');
})